import Repository from '../axios'
import {defaultPagination} from "../constants/config";
import staff from "../apis/staff";

const  resource = "/admin/suppliers";
export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getApprovedList(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/approved-suppliers?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getSupplierUsers(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/supplier/users?supplier_id=${id}&paginate=${pagination}`)
  },
  getSupplierUser(id){
    return Repository.get(`/admin/supplier/users/${id}`)
  },
  updateSupplierUser(id, payload){
    return Repository.put(`/admin/supplier/users/${id}`, payload)
  },
  supplierUserStatusChange(id, status) {
    return Repository.put(`/admin/supplier/users/${id}/${status}`)
  },
  createSupplier(payload){
    return Repository.post(`${resource}`, payload)
  },
  getSupplier(id){
    return Repository.get(`${resource}/${id}`)
  },
  createSupplierUser(payload){
    return Repository.post(`/admin/supplier/users`, payload)
  },
  approveSupplier(id, payload) {
    return Repository.put(`/admin/supplier/${id}/approve`, payload)
  },
  ReActiveSupplier(id) {
    return Repository.put(`/admin/supplier/${id}/re-activate`)
  },
  approveSupplierSite(id) {
    return Repository.put(`/admin/supplier/saq/${id}/approve`)
  },
  NotApproveSupplier(id) {
    return Repository.put(`/admin/supplier/${id}/not-approve`)
  },
  DeActivateSupplier(id) {
    return Repository.put(`/admin/supplier/${id}/suspend`)
  },
  NotApproveSite(id) {
    return Repository.put(`/admin/supplier/saq/${id}/not-approve`)
  },
  updateSupplier(id, payload){
    return Repository.put(`${resource}/${id}`, payload)
  },
  updateSupplierBasicDetails(id,payload){
    return Repository.put(`${resource}/${id}`, payload)
  },
  getBasicSupplierDetails(id) {
    return Repository.get(`${resource}/${id}`)
  },
  resendWelcomeEmail(email) {
    return Repository.put(`/admin/supplier/${email}/supplier-user-resend`)
  },
  changeSupplierstatus(id, status) {
    return Repository.put(`/admin/supplier/${id}/${status}`)
  },
  uploadFile(file) {
    return Repository.post(`/admin/supplier/file-upload`, file, {headers: {
        'Content-Type': 'multipart/form-data'
      }})
  },
  downloadECD(supplierId, rawMaterialId, formulationId, userId) {
    return Repository.get(`${resource}/${supplierId}/ecd`, { params: { raw_material_id: rawMaterialId, formulation_id: formulationId, user_id: userId }, responseType: 'blob' })
  },

};
